import PropTypes from 'prop-types';
import React from 'react';
import { createPortal } from 'react-dom';

import styles from './DisqualifyLeadModal.module.scss';

const DisqualifyLeadModal = ({
  leadName = 'this lead',
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  React.useEffect(() => {
    const handleEscape = (event) => {
      if (event.key !== 'Escape' || isSubmitting) return;
      onClose?.();
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isSubmitting, onClose]);

  const handleConfirm = async () => {
    const wasDisqualified = (await onConfirm?.()) ?? false;
    if (!wasDisqualified) return;
    onClose?.();
  };

  const modalContent = (
    <div className={styles.modalOverlay}>
      <button
        type="button"
        className={styles.modalBackdrop}
        aria-label="Close dialog"
        onClick={() => !isSubmitting && onClose?.()}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="disqualify-lead-title"
        className={styles.modalCard}
      >
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle} id="disqualify-lead-title">
            Disqualify this lead?
          </div>
        </div>

        <div className={styles.modalBody}>
          <p className={styles.modalCopy}>
            <span className={styles.modalCopyStrong}>{leadName}</span> will be marked as
            disqualified. This closes the lead&apos;s intake workflow and cancels its remaining
            tasks; no consent form or patient record will be created. This cannot be undone from
            here.
          </p>
        </div>

        <div className={styles.modalActions}>
          <button
            type="button"
            className={`${styles.modalActionButton} ${styles.modalSecondaryAction}`}
            onClick={() => onClose?.()}
            disabled={isSubmitting}
          >
            Keep lead
          </button>
          <button
            type="button"
            className={`${styles.modalActionButton} ${styles.modalDangerAction}`}
            onClick={handleConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Disqualifying...' : 'Disqualify lead'}
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return modalContent;

  return createPortal(modalContent, document.body);
};

DisqualifyLeadModal.propTypes = {
  leadName: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

export default DisqualifyLeadModal;
